export default {
  state: () => ({
    facilities: [
      {
        name: "aboutUs.consultingRoom",
        description: "aboutUs.consultingRoomDescription",
        images: [
          "/imagenes/facilities/CONSULTORIOS.jpg",
         
        ],
      },
      {
        name: "aboutUs.operatingRooms",
        description: "aboutUs.operatingRoomsDescription",
        images: [
           "/imagenes/facilities/QUIROFANOS.jpg",
        
        ],
      },
      {
        name: "aboutUs.diagnosticArea",
        description: "aboutUs.diagnosticAreaDescription",
        images: [
           "/imagenes/facilities/DIAGNOSTICA.jpg",
          
        ],
      },
      {
        name: "aboutUs.optics",
        description: "aboutUs.opticsDescription",
        images: [
           "/imagenes/facilities/OPTICA.jpg",
         
        ],
      },
      {
        name: "aboutUs.lensWorkshop",
        description: "aboutUs.lensWorkshopDescription",
        images: [
           "/imagenes/facilities/TALLER DE LENTES.jpg",
         
        ],
      },
      {
        name: "aboutUs.parking",
        description: "aboutUs.parkingDescription",
        images: [
           "/imagenes/facilities/PARQUEO incocegla.jpg",
          
        ],
      },
      
      {
        name: "aboutUs.cafeteria",
        description: "aboutUs.cafeteriaDescription",
        images: [
           "/imagenes/facilities/INCOCEGLA ROMANA.jpg",
        
        ],
      },
    ],
  }),
  getters: {
    getFacilities: (state) => state.facilities,
  },
  actions: {},
  mutations: {},
  namespaced: true,
};
